import { useQuery } from '@tanstack/react-query';
import { adsService } from '../services/ads.service';

export function useCampaign(refId: string | undefined) {
  return useQuery({
    queryKey: ['campaign', refId],
    queryFn: () => adsService.getCampaign(refId!),
    enabled: !!refId,
  });
}
